import { useEffect, useState } from "react";
import { useQuestionizerStore } from "../types/state.ts";
import { FDWAntragsteller, FDWResultEntry } from "restfd2";
import Checkbox from "./checkbox.tsx";
import LoadingIndicator from "./loading-indicator.tsx";
import Input from "./input.tsx";
import { DoiForm, LeadForm } from "./lead_form.tsx";
import { QuestionizerResultItem } from "./questionizer-result-item.tsx";

export function QuestionizerTabPanel(props: {
	  id: string,
	  active: boolean,
	  regions: Record<string, { region: string, list: Array<FDWResultEntry> }>
	}) {
		const [activeElements, setActiveElements] = useState<Set<string>>(() => {
		  const firstKey = Object.keys(props.regions)[0];
		  return new Set([firstKey]); // Set mit dem ersten Key
		});

	  const toggleElement = (key: string) => {
		setActiveElements(prev => {
		  const newSet = new Set(prev);
		  newSet.has(key) ? newSet.delete(key) : newSet.add(key);
		  return newSet;
		});
	  };

	  return (
		<div 
			id={props.id}
			role="tabpanel"
			aria-labelledby={"tab-"+props.id}
			className="accordion"
		>
		  {props.active && Object.keys(props.regions).map((key: string) => {
			const region = props.regions[key];
			const isActive = activeElements.has(key);

			return (
				<div className="accordion__element" key={key}>
					<button 
						className="accordion__element_title" 
						id={"accordion-title-"+key}
						tabIndex={0} 
						aria-expanded={isActive}
						onClick={() => toggleElement(key)}
						onKeyUp={(event) => {
						if(event.code != "Enter" && event.code != " "){return;}
						toggleElement(key)
						}}
					>
						<div className={`icon accordion__element_icon ${isActive ? "accordion__element_icon--active" : ""}`} />
						<span>{region.region} ({region.list.length})</span>
					</button>
					{isActive && 
						<div role="region"
       					 aria-labelledby={"accordion-title-"+key}>{
							region.list.map((entry: FDWResultEntry) =>
								<QuestionizerResultItem key={entry.fp_id} entry={entry} />
							)
						}</div>
					}
				</div>
			);
		  })}
		</div>
	  );
	}